import React, { useState } from 'react';
import styles from '../../../css/dashboard/ExpandableText.module.css';

const ExpandableText = ({ htmlContent }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => setExpanded(prev => !prev);

  // Strip HTML tags for preview
  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  const shortText = stripHtml(htmlContent).slice(0, 300) + '...';

  return (
    <div className={styles.expandableTextContainer}>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{
          __html: expanded ? htmlContent : shortText,
        }}
      />
      {stripHtml(htmlContent).length > 300 && (
        <button className={styles.expandButton} onClick={toggleExpand}>
          {expanded ? 'Show Less ▲' : 'Know More ▼'}
        </button>
      )}
    </div>
  );
};

export default ExpandableText;
